import React, {useState, useEffect} from 'react';
import Section from '../../libs/react-components-admin/section/section';
import OpenInNewLink from '../../libs/react-components-admin/link/open-in-new-link';
import {orgId} from '../../context/context';
import formService from '../../services/form-service';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import NoForm from './no-form';
import FormCode from './form-code';

const ViewState = {
  initial: 'initial',
  loading: 'loading',
  loaded: 'loaded',
};

const InstructionsForShopifyOsV1 = () => {

  const [viewState, setViewState] = useState(ViewState.initial);
  const [forms, setForms] = useState();

  useEffect(() => {
    setViewState(ViewState.loading);
    formService
      .findAllFormsCreatingDefaultIfEmpty()
      .then(forms => {
        setForms(forms);
        setViewState(ViewState.loaded);
      })
      .catch(err => {
        setViewState(ViewState.loaded);
        window.alert(err.stack || JSON.stringify(err));
      });
  }, []);

  if (viewState === ViewState.loading || !forms) {
    return <CenteredSpinner/>;
  }
  return <>
    <PageInstructions forms={forms}/>
    <ProductPageInstructions/>
    <CartPageInstructions/>
    <CustomerRegistrationPageInstructions/>
  </>;
};

const PageInstructions = ({forms}) =>
  <div className="row justify-content-center">
    <div className="col-12">
      {(forms || []).length === 0 ?
          <NoForm/> :
          <LoadedPageInstructions forms={forms}/>
      }
    </div>
  </div>;

const LoadedPageInstructions = ({forms}) => {

  const [selectedForm, setSelectedForm] = useState();

  const updateSelectedForm = event => {
    if (!event || !event.target || !event.target.value) {
      setSelectedForm(null);
    } else {
      const form = forms.filter(form => form.id === event.target.value)[0];
      setSelectedForm(form);
    }
  };

  return <Section title="Display your form on a page">
    <div className="row">
      <div className="col-12">
        <ol style={{marginBottom: '20px'}}>
          <li>
            Open the Shopify page where you want to add the form and click on the &apos;Show HTML&apos; icon:
            <div className="text-center"><img src="/images/shopify-show-html-button.png"
                                              alt="Shopify show HTML button" className="img-rounded"/></div>
          </li>
          <li style={{marginTop: '15px'}}>Choose the form to display:
            <select id="selectedForm" name="selectedForm"
                    className="form-select"
                    value={(selectedForm || {}).id || ''}
                    onChange={e => updateSelectedForm(e)}>
              <option key={''} value={''}/>
              {forms.map(form => <option key={form.id} value={form.id}>{form.name}</option>)}
            </select>
          </li>
          {selectedForm &&
            <>
              <li style={{marginTop: '15px'}}>
                Copy the following code:
                <FormCode form={selectedForm}/>
              </li>
              <li style={{marginTop: '15px'}}>
                Paste the code where you want to add the form:
                <div className="text-center"><img
                  src="/images/shopify-form-code-placement.png"
                  alt="Shopify form code placement" className="img-rounded"/></div>
              </li>
              <li style={{marginTop: '15px', marginBottom: '30px'}}>
                Open your Shopify page and try to submit the form to ensure everything works.
              </li>
            </>
          }
        </ol>
      </div>
    </div>
  </Section>;
};

const ProductPageInstructions = () =>
  <Section title="To remove a form from your product pages">
    <ol>
      <li>Go to your <OpenInNewLink href={`https://${orgId}/admin/themes/current`}>theme files</OpenInNewLink></li>
      <li>Search for a file named product.liquid (or similar)</li>
      <li>At the end of the file, remove the section between the 2 following markers:
        <pre>
          &lt;!-- ACERILL CUSTOM FORMS CODE --&gt;<br />
          ...<br />
          &lt;!-- END OF ACERILL CUSTOM FORMS CODE --&gt;
        </pre>
      </li>
      <li>Save the file (top right)</li>
    </ol>
  </Section>;

const CartPageInstructions = () =>
  <Section title="To remove a form from your cart page">
    <ol>
      <li>Go to your <OpenInNewLink href={`https://${orgId}/admin/themes/current`}>theme files</OpenInNewLink></li>
      <li>Search for a file named cart.liquid (or similar)</li>
      <li>At the end of the file, remove the section between the 2 following markers:
        <pre>
          &lt;!-- ACERILL CUSTOM FORMS CODE --&gt;<br />
          ...<br />
          &lt;!-- END OF ACERILL CUSTOM FORMS CODE --&gt;
        </pre>
      </li>
      <li>Save the file (top right)</li>
    </ol>
  </Section>;

const CustomerRegistrationPageInstructions = () =>
  <Section title="To remove a form from your customer registration page">
    <ol>
      <li>Go to your <OpenInNewLink href={`https://${orgId}/admin/themes/current`}>theme files</OpenInNewLink></li>
      <li>Search for a file named customers/register.liquid (or similar)</li>
      <li>At the end of the file, remove the section between the 2 following markers:
        <pre>
          &lt;!-- ACERILL CUSTOM FORMS CODE --&gt;<br />
          ...<br />
          &lt;!-- END OF ACERILL CUSTOM FORMS CODE --&gt;
        </pre>
      </li>
      <li>Save the file (top right)</li>
    </ol>
  </Section>;

export default InstructionsForShopifyOsV1;
